import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombresFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRES' htmlFor='input-nombres' md={12} />
      <Col md={12}>
        <Field name='nombres'>
          {({ field }) => (
            <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-nombres' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombresFormGroup)
